export default {
  MIN_DURATION_MINUTES: 30,
};
